module.exports = __webpack_public_path__ + "static/media/conferencia-nancy-jimenez.3235efa3.png";